<template>
  <div>
    <div class="spn-cont">
      <loading-spinner v-if="isLoading"></loading-spinner>
    </div>
    <slot v-if="!isLoading"></slot>
  </div>
</template>
<script>
import Spinner from '@/components/Spinner'
export default {
  name: 'base-page',
  components: {
    'loading-spinner': Spinner
  },
  computed: {
    isLoading () {
      return this.$store.state.isLoading
    }
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Page.vue